export default "/images/kore-hover.svg?58d5a284533d583267e2cd6fd2526201";